console.log("[LWS - Affiliation] V1.2.0");

import * as bootstrap from 'bootstrap';

import * as page_height from './modules/page_height';
import * as footer from './modules/footer';
import * as alert from './modules/alert';
import * as select from './modules/select';

import * as form from './modules/form';
import * as getresetpassword from './modules/getresetpassword';

document.addEventListener("DOMContentLoaded", function () {

    page_height.watch();
    footer.watch();
    alert.watch();

    // Selection automatique du pays dans les formulaires
    $('#MemberCountryId').each(function () {
        let ori = $(this).parent().parent().find("input[name='MemberCountryId_ori']")[0];
        if (typeof ori !== 'undefined' && ori.value.length > 0) {

            if ($(this).find('option').filter(function () {
                return $(this).attr('selected');
            }).length < 1) {
                $(this).val($(this).find('option').filter(function () {
                    return $(this).text() === ori.value;
                }).val());
            }
        }
    });

    // Détection des élements "collapse" de Bootstrap
    let loop = null;

    $(document).on('show.bs.collapse hide.bs.collapse', function (e) {

        loop = setInterval(function () {
            page_height.watch();
            footer.watch();
        }, 10); // Defaut : 10
    });

    $(document).on('shown.bs.collapse hidden.bs.collapse', function (e) {
        setTimeout(clearInterval(loop), 10);
    });

    // Détection du redimensionnements des champs
    $("textarea").on('mousedown', function () {

        loop = setInterval(function () {
            page_height.watch();
            footer.watch();
        }, 10); // Defaut : 10

    }).on('mouseup', function () {
        setTimeout(clearInterval(loop), 10);
    });

    // Intervalle de sécurité (vieux navigateurs ou faible performance)
    setInterval(function () {
        page_height.watch();
        footer.watch();
    }, 2000);

    // Gestion des formulaires V1.2
    form.watch();

    // Gestion du formulaire de réinitialisation du mot de passe
    getresetpassword.watch();
});

$(window).on("resize", function () {
    page_height.watch();
    footer.watch();
});